var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-button",
        {
          directives: [
            {
              name: "permit",
              rawName: "v-permit:remove",
              value: "btn:payable:quoteManagement:addEdit",
              expression: "'btn:payable:quoteManagement:addEdit'",
              arg: "remove",
            },
          ],
          attrs: { size: "small", type: "primary", icon: "el-icon-plus" },
          on: { click: _vm.batchAdd },
        },
        [_vm._v(_vm._s(_vm.$t("basicData.dspBatchAddition")) + " ")]
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.$t("basicData.dspBatchAddition"),
            visible: _vm.dialogVisible,
            direction: "ltr",
            size: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.reset,
          },
        },
        [
          _c("div", { staticClass: "drawer__content" }, [
            _c(
              "div",
              { staticClass: "form-container" },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      model: _vm.formData,
                      rules: _vm.rules,
                      size: "small",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("basicData.TheNameOfTheQuoteProposal"),
                          prop: "name",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.$t("orderDetails.pleaseInput"),
                            clearable: "",
                            maxlength: "50",
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.formData.name,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.formData,
                                "name",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "formData.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("basicData.TheValidityPeriodBegins"),
                          prop: "startOfValidityPeriod",
                        },
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "datetime",
                            format:
                              _vm.$i18n.locale === "zh"
                                ? _vm.zhDate
                                : _vm.ptDate,
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            "picker-options": _vm.pickerOptions,
                            placeholder: _vm.$t("basicData.SelectADatetime"),
                          },
                          model: {
                            value: _vm.formData.startOfValidityPeriod,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.formData,
                                "startOfValidityPeriod",
                                $$v
                              )
                            },
                            expression: "formData.startOfValidityPeriod",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("placeOrder.cargoType"),
                          prop: "cargoType",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              filterable: "",
                              clearable: "",
                              placeholder: _vm.$t("basicData.PleaseSelect"),
                            },
                            model: {
                              value: _vm.formData.cargoType,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "cargoType", $$v)
                              },
                              expression: "formData.cargoType ",
                            },
                          },
                          _vm._l(_vm.CARGO_TYPE, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("basicData.PartitionSchemeName"),
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("basicData.PleaseSelect"),
                              filterable: "",
                              clearable: "",
                            },
                            on: { change: _vm.getOtherFeeDetail },
                            model: {
                              value: _vm.formData.partitionId,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "partitionId", $$v)
                              },
                              expression: "formData.partitionId",
                            },
                          },
                          _vm._l(_vm.partitionList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "title" }, [
                  _vm._v(" " + _vm._s(_vm.$t("basicData.payee"))),
                ]),
                _c(
                  "el-form",
                  {
                    ref: "tableForm",
                    staticClass: "error-form mb5",
                    attrs: {
                      model: _vm.formData,
                      "label-width": "0",
                      size: "small",
                      rules: _vm.rules,
                    },
                  },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "table",
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.formData.payableOfferPriceAddList,
                          border: "",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("basicData.PayablePrincipal"),
                            "min-width": "180",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "header",
                              fn: function () {
                                return [
                                  _c("div", [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [_vm._v("*")]
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("basicData.PayablePrincipal")
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "payableOfferPriceAddList." +
                                          scope.$index +
                                          ".payableEntityId",
                                        rules: {
                                          required: true,
                                          message: _vm.$t(
                                            "basicData.CannotBeEmpty"
                                          ),
                                          trigger: ["blur", "change"],
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "basicData.PleaseSelect"
                                            ),
                                            filterable: "",
                                            clearable: "",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.chargePayable(scope)
                                            },
                                          },
                                          model: {
                                            value: scope.row.payableEntityId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "payableEntityId",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.payableEntityId",
                                          },
                                        },
                                        _vm._l(
                                          _vm.providerList,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.id,
                                              attrs: {
                                                label:
                                                  item.providerName +
                                                  "(" +
                                                  item.code +
                                                  ")",
                                                value: item.id,
                                                disabled: _vm.isOptionDisabled(
                                                  scope.$index,
                                                  item.id
                                                ),
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("basicData.Outlets"),
                            "min-width": "180",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      key: _vm.siteKey,
                                      attrs: {
                                        prop:
                                          "payableOfferPriceAddList." +
                                          scope.$index +
                                          ".siteIds",
                                      },
                                    },
                                    [
                                      _c("ElSelectV2", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          options: scope.row.siteData,
                                          filterable: "",
                                          clearable: "",
                                          size: "small",
                                          placeholder: _vm.$t(
                                            "operationCenter.PleaseSelect"
                                          ),
                                          "no-data-text": "无数据",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.handleSiteChange(scope)
                                          },
                                        },
                                        model: {
                                          value: scope.row.siteIds,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "siteIds", $$v)
                                          },
                                          expression: "scope.row.siteIds",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("basicData.operate"),
                            width: "100",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-popconfirm", {
                                    attrs: {
                                      title: _vm.$t(
                                        "basicData.AreYouSureYouWantToDelete"
                                      ),
                                    },
                                    on: {
                                      confirm: function ($event) {
                                        return _vm.handleDel(scope)
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "reference",
                                          fn: function () {
                                            return [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "danger",
                                                    size: "mini",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("basicData.Delete")
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "feet-r" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "small",
                          type: "primary",
                          icon: "el-icon-plus",
                        },
                        on: { click: _vm.add },
                      },
                      [_vm._v(_vm._s(_vm.$t("basicData.Add")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "feet-btn",
                        attrs: {
                          loading: _vm.isLoading,
                          size: "small",
                          icon: "el-icon-download",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.downloadFile(1)
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("collectionCenter.TemplateDownload"))
                        ),
                      ]
                    ),
                    _c("upload-excel", {
                      staticClass: "feet-btn",
                      attrs: {
                        "on-success": _vm.importProviderData,
                        "but-name": _vm.$t("collectionCenter.Import"),
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "drawer__footer feet-r" },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      loading: _vm.isLoading,
                      size: "small",
                      icon: "el-icon-download",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.downloadFile(2)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("collectionCenter.TemplateDownload")))]
                ),
                _c("upload-excel", {
                  staticClass: "feet-btn",
                  attrs: {
                    "on-success": _vm.importData,
                    "but-name": _vm.$t("collectionCenter.Import"),
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }